export default "__VITE_ASSET__BGUK8f2W__"